import { GuideVisualCard } from "@/components/home/GuideVisualCard";

export const GuideEffectPreview = ({ content }) => {
  const effect = content?.guides_card_effect || "cinematic";
  const enabled = content?.guides_effects_enabled !== false;
  const sampleGuide = {
    id: "guide-effect-preview",
    name: "Guide Name",
    photo_url: content?.hero_image || "",
    photo_position_x: 50,
    photo_position_y: 50,
    photo_zoom: 1,
  };
  return (
    <div className="rounded-2xl border border-border bg-[#F4F1EA]/70 p-4" data-testid="guide-effect-preview">
      <p className="text-xs uppercase tracking-widest text-muted-foreground mb-3">Live effect preview</p>
      <div className={`w-44 ${effect === "spotlight" && enabled ? "group/grid" : ""} ${effect === "tilt" && enabled ? "[perspective:1200px]" : ""}`}>
        <GuideVisualCard guide={sampleGuide} index={0} effect={effect} effectsEnabled={enabled} />
      </div>
      <p className="mt-3 text-xs text-muted-foreground">Preview updates as you change the effect. Click Save content to publish.</p>
    </div>
  );
};
